<section class="w-full px-4 pt-4" aria-labelledby="billing-page-heading">
  <h1 id="billing-page-heading" class="sr-only">Billing</h1>

  <app-billing-overview
    class="block w-full"
    [summary]="summary()"
    [payments]="payments()"
    [isPaymentsLoading]="isPaymentsLoading()"
    [isPaymentsLoaded]="isPaymentsLoaded()"
    [invoices]="invoices()"
    [isInvoicesLoading]="isInvoicesLoading()"
  ></app-billing-overview>
</section>
